import React from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import "./NoviceGuidePage.css";

function NoviceGuidePage() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Header />
      <div className="novice-guide">
        <div className="novice-guide-content">
          <h1>
            Novice's Guide to Getting into Practical Shotgun with Romsey
            Shooting Club
          </h1>
          <p className="novice-guide-subtitle">
            This guide is to advise novices how to successfully join the Romsey
            Shooting Club.
          </p>
          <p>
            A novice is considered to be someone who does not currently hold a
            Firearms Certificate (FAC) and/or someone that does not have any
            Section 1 Shotgun Target or Practical experience.
          </p>
          <p>
            Some exceptions can be made for "prior firearms shotgun experience"
            depending on the circumstances.
          </p>

          <section>
            <h2>Pre-requisites</h2>
            <ol className="novice-guide-list">
              <li>
                The person must not be barred from holding a Firearms
                Certificate (FAC). A section 21 declaration will be required. —
                Please review the{" "}
                <a
                  href="https://www.legislation.gov.uk/ukpga/1968/27/section/21"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  legislation
                </a>
              </li>
              <li>
                The person must be able to satisfy the requirements for the safe
                storage of firearms —{" "}
                <a
                  href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/117794/security_leaflet.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View requirements
                </a>
              </li>
              <li>
                Due to the nature of the sport, the person should be reasonably
                physically fit as it requires movement across variable ground,
                bending/stretching and the ability to hold a heavy gun for a
                while. This is a safety requirement.
              </li>
              <li>
                Patience. The application and firearms licensing can be a
                lengthy process (Currently applications to Hampshire Police take
                approximately 9 months).
              </li>
              <li>
                The person should consider the financial implications that can
                accommodate the sport. (Shotguns typically can range in price
                from £300 to £8000 and each shotgun cartridge costs 35p or
                above).
              </li>
              <li>
                Have personal circumstances that can accommodate the time
                commitment required. The firearms licensing require you to be
                able to demonstrate regular shooting attendance.
              </li>
              <li>Be willing and able to learn.</li>
            </ol>
          </section>

          <section>
            <h2>The Process</h2>
            <ol className="novice-guide-list">
              <li>
                <strong>Stage One</strong> — Come and visit us at a pre-arranged
                appointment. You will generally not be able to shoot on this
                visit. This will allow you to see the sport in action and tour
                our facilities. You will be able to ask any questions and we can
                discuss the further stages.
                <div className="novice-guide-note">
                  We are expected by the Police to verify you are of good
                  character before you can be considered for membership, see{" "}
                  <a
                    href="https://www.gov.uk/government/publications/approval-of-rifle-and-muzzle-loading-pistol-clubs/approval-of-rifle-and-muzzle-loading-pistol-clubs-accessible"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    club approval requirements
                  </a>
                </div>
              </li>
              <li>
                <strong>Stage Two</strong> — Attend on a specified guest
                shooting day. You will get to see some experienced shooters,
                various guns and equipment and try some practical shotgun
                shooting, with either a club loaned Section 2 Shotgun (3 shot)
                under supervision or your own Section 2 Shotgun if you hold a
                Shotgun Certificate (SGC).
              </li>
              <li>
                <strong>Stage Three</strong> — Apply for Probationary Membership
                with the club. You will need to complete an online application
                and pay the £15 Probationers fee. You will be subject to Police
                Screening on this probationary application.
              </li>
              <li>
                <strong>Stage Four</strong> — Attend the club regularly and be
                instructed in a basic safety induction process (to demonstrably
                learn how to handle a gun and necessary range
                commands/disciplines etc). This can be on practice/training
                days, and when you/we are confident you can progress to compete
                in club competitions.
              </li>
              <li>
                <strong>Stage Five</strong> — When you have satisfactorily
                completed the above you will be considered for full membership
                by the committee. If approved you will be invited to upgrade to
                a full membership. There are a few different options which will
                be discussed with you before this stage and then you will need
                to pay the appropriate fee.
              </li>
            </ol>
          </section>

          <section>
            <p>
              Once you have achieved full membership you can then apply for a
              Firearms Certificate from your police authority. It will be a
              lengthy process and there are no short cuts. But we will do our
              best to offer you advice.
            </p>
            <p>
              You will be expected to undertake a formal safety course, usually
              within 2 years, either with us, or elsewhere at another venue
              (NRA, UKPSA & other clubs run them). We will need to be supplied
              details of you passing this course.
            </p>
            <p>
              There are too many variables to explain all possible
              considerations here, but we have amongst us a vast pool of
              knowledge and experience to answer most questions, and you will
              have plenty of opportunity to talk to us during the process.
            </p>
            <p className="novice-guide-final">
              Finally, practical shotgun is a very rewarding
              sport/hobby/pastime, with an outstanding safety record to uphold,
              but it is difficult to get into for a reason, and if we have to
              explain that to you, we suggest you take up golf…… 😊
            </p>
          </section>

          <section>
            <h2>Terminology</h2>
            <ol className="novice-guide-list">
              <li>
                <strong>Firearms Certificate (FAC)</strong> — This is the
                certificate that allows you to hold a Section 1 firearm or
                shotgun in the UK. It is granted by your local Police authority.
              </li>
              <li>
                <strong>Shotgun Certificate (SGC)</strong> — This is the
                certificate that allows you to hold a Section 2 shotgun in the
                UK. It is granted by your local Police authority.
              </li>
              <li>
                <strong>Section 2 Shotgun</strong> — A shotgun which can hold NO
                MORE than 3 shots.
              </li>
              <li>
                <strong>Section 1 Shotgun</strong> — A shotgun which can hold
                more than 3 shots.
              </li>
              <li>
                <strong>Section 21 Declaration</strong> — A declaration required
                by the Police to ensure you are of good character and will not
                be a danger to yourself or others.
              </li>
              <li>
                <strong>Probationary Membership</strong> — Membership which is
                granted to those who require a probationary period to be trained
                and assessed for full membership.
              </li>
              <li>
                <strong>Full Membership</strong> — Membership which is granted
                to those who have satisfactorily completed the probationary
                period. This is required BEFORE you can apply for a firearms
                certificate.
              </li>
            </ol>
          </section>
          <footer className="novice-guide-version">Version 5, February 2025</footer>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NoviceGuidePage;
